module.exports = __webpack_public_path__ + "assets/img/free_24.fd087e34.png";